import { Avatar, Box, Card } from '@factorialco/deprecated-design-system'

import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import { platformData } from 'modules/nps/lib/platformData'

export const ReviewGrid = () => {
  const handleReviewClick = (url: string, name: string) => {
    track(trackingEvents.nps.clickReview, { platform: name })
    window.open(url)
  }

  return (
    <Box style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }} paddingTop="s32">
      {platformData.map((item) => (
        <Box key={item.name}>
          <Card height="s120" onClick={() => handleReviewClick(item.url, item.name)}>
            <Card.Eyebrow>
              <Avatar label={item.name} url={item.icon} size="s32" />
            </Card.Eyebrow>
            <Card.Title size="small">
              {i18n.t('nps.survey_page.review.submit', { platform: item.name })}
            </Card.Title>
          </Card>
        </Box>
      ))}
    </Box>
  )
}
